import React from 'react'

const AboutUs = () => {
	return (
		<div className="container my-20 flex flex-col gap-y-6 px-10 text-center sm:my-28 sm:grid md:grid-cols-12 md:grid-rows-3 md:gap-y-10 md:text-left">
			<p className="col-span-2 col-start-4 text-3xl font-bold text-primary">
				5 let
			</p>
			<p className="col-span-5">
				již vyvíjíme mobilní a webové aplikace pro naše klienty.
			</p>
			<p className="col-span-2 col-start-4 row-start-2 text-3xl font-bold text-primary">
				6 členů
			</p>
			<p className="col-span-5 col-start-6 row-start-2">
				týmu Notify se o vás bude starat pro maximální komfort.
			</p>
			<p className="col-span-2 col-start-4 row-start-3 text-3xl font-bold text-primary">
				14 dnů
			</p>
			<p className="col-span-5 col-start-6 row-start-3">
				je maximální doba, kterou potřebujeme pro vytvoření aplikace.{' '}
			</p>
		</div>
	)
}

export default AboutUs
